// extracted by mini-css-extract-plugin
export var fallback = "_7-0";
export var fallbackButton = "_7-4";
export var fallbackIcon = "_7-1";
export var fallbackMessage = "_7-3";
export var fallbackTitle = "_7-2";